/**
 * FieldError — inline validation message under a form control.
 *
 * Give the control `aria-invalid` and `aria-describedby={id}` so screen
 * readers announce the message with the field. Renders nothing without a
 * message.
 *
 * Props:
 *  - id: string — referenced by the control's aria-describedby
 *  - message: string | null
 */

import React from 'react';
import './FieldError.css';

export default function FieldError({ id, message }) {
  if (!message) return null;
  return (
    <span id={id} className="field-error" role="alert">
      {message}
    </span>
  );
}
